import http from 'hub-http/clients/apiClient';
import cloneDeep from 'hs-lodash/cloneDeep';
import { getPropertyValue, setPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
export async function updateWhatsApp({
  crmObject,
  changes
}) {
  const contentId = getPropertyValue(crmObject, 'hs_content_id');

  /**
   * Create a copy of the existing crm object applying new values coming from {@link changes}
   * This API doesnt return a CRM object as a response so we have to manually return
   * the updated CRM object
   */
  let updatedCRMObject = cloneDeep(crmObject);
  const payload = {};
  Object.keys(changes).forEach(propertyName => {
    updatedCRMObject = setPropertyValue(updatedCRMObject, propertyName, changes[propertyName]);
    if (propertyName === 'hs_name' && changes[propertyName]) {
      payload.name = changes[propertyName];
    }
  });
  await http.put(`messaging-whatsapp/v1/whatsapp/${contentId}`, {
    data: payload
  });
  return updatedCRMObject;
}